var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Link } from "../Link";
var FooterV2BottomCopy = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, style = _a.style, otherProps = __rest(_a, ["children", "className", "style"]);
    var classFooterBottomCopy = "fr-footer__bottom-copy";
    if (className) {
        classFooterBottomCopy += " ".concat(className);
    }
    var content = (React.createElement("p", null,
        "Sauf mention explicite de propri\u00E9t\u00E9 intellectuelle d\u00E9tenue par des tiers, les contenus de ce site sont propos\u00E9s sous",
        " ",
        React.createElement(Link, { href: "https://github.com/etalab/licence-ouverte/blob/master/LO.md", external: true, title: "Licence etalab" }, "licence etalab-2.0")));
    return (React.createElement("div", __assign({}, otherProps, { className: classFooterBottomCopy, style: style, ref: ref }), children ? children : content));
});
export default FooterV2BottomCopy;
